import { TRoom } from './Orl.types';

export const getTravelersCount = (rooms?: Array<TRoom>): TRoom => {
  return (rooms || []).reduce(
    (previous, current) => ({
      adults: previous.adults + current.adults,
      children: previous.children + current.children,
    }),
    {
      adults: 0,
      children: 0,
    }
  );
};
